export const karteTrackingId = {
  BUTTON: 'karte_button',
} as const;
